<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 20.16 20.161">
  <g id="Raggruppa_13597" data-name="Raggruppa 13597" transform="translate(0 0)">
    <g id="Raggruppa_13213" data-name="Raggruppa 13213">
      <path id="Tracciato_9320" data-name="Tracciato 9320" d="M19.668,8.536,11.268.472a1.732,1.732,0,0,0-2.376,0L.492,8.536A1.575,1.575,0,0,0,0,9.678v9.676a.824.824,0,0,0,.84.807H7.56a.824.824,0,0,0,.84-.807V13.71h3.36v5.644a.824.824,0,0,0,.84.807h6.72a.824.824,0,0,0,.84-.807V9.678a1.575,1.575,0,0,0-.492-1.142M18.48,18.548H13.44V12.9a.824.824,0,0,0-.84-.806H7.56a.824.824,0,0,0-.84.806v5.645H1.68V9.678l8.4-8.064,8.4,8.064Z"/>
    </g>
  </g>
</svg>
